import { type FC, useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { SlabContext } from '@core/context/SlabContext';

import { UnboundSlabRoutes } from '../../SlabRoutes';
import { ReferButton } from '../ReferButton/ReferButton';
import AppDrawerLogo from './AppDrawerLogo';
import AppLogout from './AppLogout';
import NavOption from './NavOption';
import { SectionList } from './SectionList';
import { Drawer, SectionWrapper } from './styles';

interface AppDrawerProps {
  isOpen: boolean;
  isMobile: boolean;
  closeDrawer(): void;
  openDrawer(): void;
}

const AppDrawer: FC<AppDrawerProps> = ({ isOpen, isMobile, closeDrawer, openDrawer }) => {
  const navigate = useNavigate();

  const { userInfo } = useContext(SlabContext);

  const navigationSections = useMemo(() => UnboundSlabRoutes(userInfo), [userInfo]);

  const handleReferClick = (): void => {
    navigate('/refer');
    if (isMobile) {
      closeDrawer();
    }
  };

  return (
    <Drawer variant='permanent' isOpen={isOpen} onClose={closeDrawer}>
      <AppDrawerLogo isOpen={isOpen} closeDrawer={isOpen ? closeDrawer : openDrawer} />

      <SectionList
        sectionWrapper={<SectionWrapper />}
        sections={navigationSections}
        keyExtractor={(_, index) => String(index)}
        sectionKeyExtractor={(_, index) => String(index)}
        renderItem={({ item }) => (
          <NavOption isMobile={isMobile} closeDrawer={closeDrawer} isOpen={isOpen} route={item} />
        )}
      />

      <SectionWrapper>
        <ReferButton isOpen={isOpen} onClick={handleReferClick} />
      </SectionWrapper>
      <SectionWrapper>
        <AppLogout isOpen={isOpen} />
      </SectionWrapper>
    </Drawer>
  );
};

export default AppDrawer;
